import { u3207QuotaBarWidthPercent } from '../utils/u3207Formatters';

interface U3207QuotaBarProps {
  usagePercent: number | null;
  label?: string;
}

function U3207QuotaBar({ usagePercent, label }: U3207QuotaBarProps) {
  const width = u3207QuotaBarWidthPercent(usagePercent);
  if (usagePercent == null) return null;

  return (
    <div className="mt-2">
      {label ? <p className="mb-1 text-xs text-muted-foreground">{label}</p> : null}
      <div className="h-2 w-full overflow-hidden rounded-sm bg-muted">
        <div
          className="h-full rounded-sm bg-primary transition-[width]"
          style={{ width: `${width}%` }}
          role="progressbar"
          aria-valuenow={Math.round(width)}
          aria-valuemin={0}
          aria-valuemax={100}
        />
      </div>
    </div>
  );
}

export default U3207QuotaBar;
